import styled from 'styled-components'
import { formatDistance } from 'date-fns'

import { Text } from '@h2/components/typography/text'
import { Box } from '@h2/components/layout/box'
import { NotificationIcon } from '@h2/components/icons/notification'
import { PB90T, PB70T, PB97T } from '@h2/components/colors'
import { Link } from '@h2/common/components/link'
import { useDateFnsLocale } from '@h2/common/components/hooks/useDateFnsLocale'

const StyledLink = styled(Link)`
  display: flex;
  width: 100%;
  min-height: 30px;
  align-items: flex-start;
  padding: 7px;
  border-bottom: solid 1px ${PB90T};

  :link {
    text-decoration: none;
  }

  :first-of-type {
    border-top: solid 1px ${PB90T};
  }

  :hover {
    background-color: ${PB97T};
  }
`
const FeedItem = ({ item = {} }) => {
  const locale = useDateFnsLocale()

  return (
    <StyledLink href={item.url}>
      <NotificationIcon size="tiny" />
      <Box style={{ width: '100%' }}>
        <Text weight="bold" margin="0 0 0 8px">
          {item.subject}
        </Text>
        <Text className="FeedItem-BodyText" size="small" margin="0 0 0 8px">
          {item.body || ''}
        </Text>
        <Text align="right" color={PB70T} size="small" margin="4px 0 0 0">
          {formatDistance(new Date(item.received), new Date(), {
            addSuffix: true,
            ...locale
          }) || ''}
        </Text>
      </Box>
    </StyledLink>
  )
}

export { FeedItem }
